import StorageObject from 'ember-local-storage/local/object';

const Storage = StorageObject.extend();

Storage.reopenClass({
  initialState() {
    return {
      fundSummaryChartShowIncome: true,
      fundSummaryChartShowExpense: false,
      fundSummaryChartShowGoal: true,
      fundSummaryChartShowBalance: true,
      adminUsersIndexSortByProperty: 'user.displayName',
      adminUsersIndexSortByDirection: 'asc',
      journalShowLastIntervalCount: 0,
      journalDefaultReportHideStageNames: null, // if present, then CSV string of stage names
    };
  },
});

export default Storage;
